<template>

    
<draggable v-model="renderedForms" @end="changeDrag" tag="div" >
    <template #item="{ element: form }" >
        <div class="flex p-3 bg-slate-800 rounded-md my-3 items-center">
            <div class="shrink-1 cursor-pointer">
                <i class="pi pi-ellipsis-v"></i>
            </div>
            <div v-if="!['nome','cognome','email','sede'].includes(form['dati']['nome'])">
                <button class="mx-1 p-button  p-button-icon-only p-button-secondary p-button-rounded p-button-text  " @click="elimina(form['dati']['index'])">
                    <i class="pi pi-trash text-red-500 hover:violet-600"></i>
                </button>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-5 gap-3 grow" >
                    <template v-for="(value, key) in form['labels']">
                        <div v-if="(value[1] === 'text' || value[1] === 'email')">
                            <FloatLabel class="w-full" variant="on">
                                <InputText v-model="form['dati'][key]" class="w-full" :type="value[1]" :name="key" @change="checkNameDuplicate(form['dati'].index, key)" :invalid="errors[form['dati'].index] !== undefined && key in errors[form['dati'].index]"/>
                                <label :for="key">{{ value[0] }} <span v-if="value[2] === 'required'">*</span></label>
                            </FloatLabel>
                            <Message v-if="errors[form['dati'].index] !== undefined && key in errors[form['dati'].index]" severity="error" size="small" variant="simple">
                                {{ errors[form['dati'].index][key] }}
                            </Message>
                        </div>
                        <div class="col-span-4" v-if="value[1] === 'textarea'">
                            <label :for="key">{{ value[0] }} <span v-if="value[2] === 'required'">*</span></label>
                            <Textarea :name="key" v-model="form['dati'][key]" class="w-full" rows="10"
                                            :invalid="errors[form['dati'].index] !== undefined && key in errors[form['dati'].index]">
                                {{ form['dati'][key] }}
                            </Textarea>
                            <Message v-if="errors[form['dati'].index] !== undefined && key in errors[form['dati'].index]" severity="error" size="small" variant="simple">
                                {{ errors[key] }}
                            </Message>
                        </div>
                        <div v-if="value[1] === 'select'">
                            <FloatLabel class="w-full" variant="on">
                                <Select v-model="form['dati'][key]" :options="value[3]" :name="key" optionLabel="nome" optionValue="id"
                                                :placeholder="value[4]"
                                                class="w-full" @change="handleSelectChange(form['dati'].index, key)"/>
                                <label :for="key">{{ value[0] }} <span v-if="value[2] === 'required'">*</span></label>
                            </FloatLabel>
                            <Message v-if="errors[form['dati'].index] !== undefined && key in errors[form['dati'].index]" severity="error" size="small" variant="simple">
                                {{ errors[form['dati'].index][key] }}
                            </Message>
                        </div>
                        
                        <div v-if="value[1] === 'select-add'">
                            <FloatLabel class="w-full" variant="on">
                                <Select v-model="form['dati'][key]" :options="value[3]" :name="key" optionLabel="nome" optionValue="id"
                                                :placeholder="value[4]"
                                                class="w-full" :invalid="errors !== undefined && key in errors">
                                    <template #footer>
                                        <div class="p-3">
                                            <Button :label="$root.trans.aggiungi_nuovo" @click="showModal[`${key}_${form['dati'].index}`] = true"
                                                            fluid severity="secondary" text size="small" icon="pi pi-plus"/>
                                        </div>
                                    </template>
                                </Select>
                                <label :for="key">{{ value[0] }} <span v-if="value[2] === 'required'">*</span></label>
                            </FloatLabel>
                            <Dialog v-model:visible="showModal[`${key}_${form['dati'].index}`]" modal :header="$root.trans.aggiungi+' '+value[0]"
                                            :style="{ width: '25rem' }">

                                <FormInput
                                    :dati="value[6]"
                                    :formlabel="value[5]"
                                    stilestruttura="grid grid-cols-1 md:grid-cols-1 gap-3"
                                    :action="value[7]"
                                    :ref="'modalinput_'+`${key}_${form['dati'].index}`">
                                </FormInput>
                                <a type="button" class="p-button p-component p-button-secondary"
                                    @click="showModal[key] = false">{{ $root.trans.annulla }}</a>
                                <button @click="checkModale(`${key}_${form['dati'].index}`)" class="p-button p-component p-button-success">
                                    <span class="p-button-label">{{ $root.trans.aggiungi }}</span>
                                </button>
                            </Dialog>
                            <Message v-if="errors !== undefined && key in errors" severity="error" size="small" variant="simple">
                                {{ errors[key] }}
                            </Message>
                        </div>
        
                        <template v-if="value[1] === 'hidden'">
                            <input v-model="form['dati'][key]" class="w-full" type="hidden" :name="key">
                        </template>
                    </template>
            </div>
        </div>
    </template>
</draggable>
    
    <div class="flex justify-around"> 
        <Button @click="addRow" class="p-button p-component p-button-success !rounded-full">
            <i class="pi pi-plus"></i>
        </Button>
    </div>
    <div class="flex justify-end">
        <Button @click="save" class="p-button p-component p-button-success">
            Salva
        </Button>
    </div>
</template>
<style scoped>

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>
<script>
import InputText from 'primevue/inputtext';
import Editor from 'primevue/editor';
import DatePicker from 'primevue/datepicker';
import InputNumber from 'primevue/inputnumber';
import Checkbox from 'primevue/checkbox';
import Select from 'primevue/select';
import FloatLabel from 'primevue/floatlabel';
import Message from 'primevue/message';
import Textarea from 'primevue/textarea';   
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import RadioButton from 'primevue/radiobutton'
import FormInput from './FormInput.vue';
import { nextTick } from 'vue';
import axios from 'axios';
import draggable from 'vuedraggable';

export default {
    name: 'ModuloBuilder',
    components: {
        InputText,
        Editor,
        Textarea,
        DatePicker,
        InputNumber,
        Checkbox,
        RadioButton,
        Select,
        FloatLabel,
        Message,
        Button,
        Dialog,
        FormInput,
        draggable
    },
    props: ['fields', 'codifiche', 'forms','id','tipologia'],
    data() {
        return {
            errors: [],
            campi: [],
            sezioni: [],
            showModal:[],
            renderedForms: [],
            formInputCampi: [],
            formInputDati: [],
        }
    },
    created: function () {
        this.sezioni = this.codifiche;
        this.forms.forEach((form, index) => {
            if(this.fields[index].tipologia == 'select' || this.fields[index].tipologia == 'select-multipla' || this.fields[index].tipologia == 'radio'){
                form['opzioni'] = [this.$root.trans.onoffboarding_modulo_opzioni, 'textarea', '', ''];
            }
            this.fields[index]['index'] = index;
            this.renderedForms.push({
                labels: form,
                dati: this.fields[index]
            })
        })
        console.log(this.renderedForms)
       
    },
    methods: {
        changeDrag(e){
            this.renderedForms.forEach((form, index) => {
                form['dati']['index'] = index;
            })
        },
        addRow() {
            const onoffboarding_form = {
            'id': ['id', 'hidden'],
            'tipologia': ['tipologia', 'hidden'],
            'codifica': [this.$root.trans.nome, 'text', 'required', ''],
            'is_modale': ['modale', 'hidden', '', ''],
            };
            const emptyForm = {
                'id': 0,
                'tipologia': this.tipologia == 'onboarding' ? 1 : 2,
                'codifica': '',
                'is_modale': 1,
            }

            const sottoForm = {
                'id': ['id', 'hidden'],
                'nome': [this.$root.trans.nome, 'text', 'required', ''],
                'tipologia': [this.$root.trans.tipo, 'select', 'required', [
                    { id: 'text', nome: this.$root.trans.onoffboarding_campi_testo},
                    { id: 'textarea', nome: this.$root.trans.onoffboarding_campi_textarea},
                    { id: 'select', nome: this.$root.trans.onoffboarding_campi_select},
                    { id: 'select-multipla', nome: this.$root.trans.onoffboarding_campi_select_multipla},
                    { id: 'radio', nome: this.$root.trans.onoffboarding_campi_checkbox},
                    { id: 'checkbox', nome: this.$root.trans.onoffboarding_campi_radio},
                    { id: 'date', nome: this.$root.trans.onoffboarding_campi_data},
                    { id: 'number', nome: this.$root.trans.onoffboarding_campi_numero},
                ]],
                //'opzioni': ['Opzioni', 'text', '', ''],
                'label': [this.$root.trans.label, 'text', 'required', ''],
                'onoffboarding_codifica_id': [this.$root.trans.onoffboarding_codifica, 'select-add', 'required', this.sezioni,'',onoffboarding_form,emptyForm, route('moduli/codifica/salva')],
            }
            const datiPartenza = {
                'id': 0,
                'index': this.renderedForms.length,
                'nome': '',
                'tipologia': '',
                'opzioni': '',
                'label': '',
                'onoffboarding_codifica_id': 0,
            }
            if(this.renderedForms.length < 30){
                
                this.renderedForms.push({
                    labels: sottoForm,
                    dati: datiPartenza
                })
            }else{
                this.$toast.add({
                    severity: 'errors',
                    summary: this.$root.trans.errors_form,
                    detail: this.$root.trans.massimo_30,
                    life: 3000
                });   
            }
        },
        checkModale: function (key) {
			var vm = this.$refs['modalinput_' + key][0];
			var vm_father = this;
			var b = false;

			for (const [key, value] of Object.entries(vm.label)) {
				if (typeof value[2] != "undefined" && value[2] !== "") {
					if (value[2].includes('|') === false) {
						if (value[2].includes(':')) {
							var key_c = index.split(":");
							if (vm.inputValidation(key, key_c[1], key_c[0], value[1], value[0])) {
								b = true;
							}
						} else {
                            if (vm.inputValidation(key, null, value[2], value[1], value[0])) {
								b = true;
							}
						}
					} else {
                        var array_validazioni = value[2].split("|");
						array_validazioni.forEach((index) => {
                            if (index.includes(':')) {
                                var key_c = index.split(":");
								if (vm.inputValidation(key, key_c[1], key_c[0], value[1], value[0])) {
									b = true;
								}
							} else {
                                if (vm.inputValidation(key, null, index, value[1], value[0])) {
									b = true;
								}
							}
						});
					}
				}
			}
			if (!b) {
				try {
					axios.post(vm.action, vm.info)
						.then(function (response) {
							if (response.data.success) {
								const key_original = key.split("_").slice(0, -1).join("_");
                                vm_father.renderedForms.map((form)=>{
                                    form.labels[key_original][3].push(response.data.value);
                                    if(form.dati.index == key.split("_").slice(-1)[0]){
                                        form.dati[key_original] = response.data.value.id;
                                    }
                                })                                
								vm_father.sezioni.push(response.data.value);
                                vm_father.showModal[key] = false
							} else {
								this.$toast.add({
									severity: 'errors',
									summary: this.$root.trans.errors_form,
									detail: this.$root.trans.salvataggio_errato,
									life: 3000
								});
							}
						}.bind(this));
				} catch (error) {
					if (error.response && error.response.status === 401) {
						this.$toast.add({
							severity: 'errors',
							summary: this.$root.trans.errors_form,
							detail: this.$root.trans.salvataggio_errato,
							life: 3000
						});
					}
				}
			}
		},
        checkNameDuplicate(ind, key) {
            if (key == 'nome') {
                let fieldHasError = false;
                this.renderedForms.forEach((form, index) => {
                    if (form['dati']['nome'] === this.renderedForms[ind]['dati']['nome'] && form['dati']['index'] !== ind) {
                        fieldHasError = true;
                        if (this.errors[ind] === undefined) {
                            this.errors[ind] = {};
                        }
                        this.errors[ind][key] = this.$root.trans.campo_duplicato
                        this.$toast.add({
                            severity: 'errors',
                            summary: this.$root.trans.errors_form,
                            detail: this.$root.trans.campo_duplicato,
                            life: 3000
                        })
                    }
                })

                if(fieldHasError){
                    if(this.errors[ind] === undefined) {
                        this.errors[ind] = {};
                    }
                    this.errors[ind][key] = this.$root.trans.campo_duplicato
                }else{
                    if(this.errors[ind] !== undefined && key in this.errors[ind]){
                        delete this.errors[ind][key];
                        if (Object.keys(this.errors[ind]).length === 0) {
                            delete this.errors[ind];
                        }
                    }
                }
            }
        },
        save() {
            try {
                
                if (this.errors.length > 0){
                    return
                }
                
                axios.post('/moduli/salva', {
                    tipologia: this.tipologia,
                    forms: this.renderedForms.map(form => form.dati),
                    id: this.id,
                })
                .then(response => {
                    console.log(response.data);
                    if (response.data.success) {
                        this.$toast.add({
                            severity: 'success',
                            summary: this.$root.trans.success_form,
                            detail: this.$root.trans.salvataggio_success,
                            life: 3000
                        });
                        if (response.data.params) {
                            window.location.href = route(response.data.redirect, response.data.params);
                        } else {
                            window.location.href = route(response.data.redirect);
                        }
                    }else{
                        if (response.data.message != null) {
                            this.$toast.add({
                                severity: 'errors',
                                summary: this.$root.trans.errors_form,
                                detail: this.$root.trans[response.data.message],
                                life: 5000
                            });
                        } else {
                            this.$toast.add({
                                severity: 'errors',
                                summary: this.$root.trans.errors_form,
                                detail: this.$root.trans.salvataggio_errato,
                                life: 3000
                            });
                        }
                    }
                })
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    this.$toast.add({
                        severity: 'errors',
                        summary: this.$root.trans.errors_form,
                        detail: this.$root.trans.salvataggio_errato,
                        life: 3000
                    });
                }
            }
        },
        handleSelectChange(index, key) {
            if(key == 'tipologia'){
                if(this.renderedForms[index]['dati']['tipologia'] != 'select' && this.renderedForms[index]['dati']['tipologia'] != 'select-multipla' && this.renderedForms[index]['dati']['tipologia'] != 'radio'){
                    delete this.renderedForms[index]['labels'].opzioni;
                }else{
                    this.renderedForms[index]['labels']['opzioni'] = [this.$root.trans.onoffboarding_modulo_opzioni, 'textarea', '', ''];
                }
            }
            
        },
        elimina(index){
            this.renderedForms.splice(index, 1);
            this.renderedForms.forEach((form, index) => {
                form['dati']['index'] = index;
            })
        }
    }
}
</script>